// Vendor dependencies snapped from external.js
import "./external_vendor.js";

// Application specific code references (relative to original location)
import "original_assets/modernizr.custom.js";
import "original_assets/jquery-ui-1.10.3.custom.min.js";
import "original_assets/placeholder.js";
import "original_assets/fullscreen.js";
import "original_assets/froogaloop.min.js";
